import React from 'react';

/**
 * HeroImage Component
 *
 * A specialized image component for hero images that:
 * - Loads immediately (no lazy loading) — it is the LCP element
 * - fetchpriority="high" signals this as the most important image on the page
 * - Explicit width/height prevent Cumulative Layout Shift (CLS) by reserving
 *   space before the image loads (all hero images are 1300×700px)
 *
 * @param {string} src - Image source URL
 * @param {string} alt - Alt text for accessibility
 * @param {string} className - Additional CSS classes
 * @param {function} onLoad - Optional load callback
 * @param {function} onError - Optional error callback
 */
const HeroImage = ({
  src,
  alt = '',
  className = '',
  onLoad,
  onError,
  ...props
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`hero-img ${className}`}
      loading="eager"
      fetchpriority="high"
      width="1300"
      height="700"
      onLoad={onLoad}
      onError={onError}
      {...props}
    />
  );
};

export default HeroImage;
